export const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: '18px',
  background: 'white',
  padding: '0',
  cursor: 'context-menu',
  borderBottom: '1px solid gray',
};

export const style = {
  display: 'flex',
  textAlign: 'left',
  cursor: 'context-menu',
  borderRight: 'none',
  height: 53.6,
};
